import React from 'react'
import { Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';

export default function ModalForm() {
    return (
        <div>
            <Form>
                <FormGroup row>
                    <Label for="price" sm={3}>Sell price</Label>
                    <Col sm={9}>
                        <Input className="hideArrows" type="number" name="price" id="price"
                        //placeholder="with a placeholder" 
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="buyPrice" sm={3}>Buy price</Label>
                    <Col sm={9}>
                        <Input className="hideArrows" type="number" name="buyPrice" id="buyPrice"
                        //placeholder="password placeholder" 
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="options" sm={3}>Options</Label>
                    <Col sm={9}>
                        <Input type="select" name="options" id="options" />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="exampleText" sm={3}>Text Area</Label>
                    <Col sm={9}>
                        <Input type="textarea" name="text" id="exampleText" />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col>
                        <Button style={{
                            width: "100%"
                        }}
                        className="btn-outline-dark salesDeskBtn checkout btn btn-secondary mt-3"
                        >Submit</Button>
                    </Col>
                </FormGroup>
            </Form>
        </div>
    )
}
